export default function ContentElementQuote(Element) {
  if (!Element) return;
  const { quote } = Element;
  const text = `&bdquo;${quote?.text}&rdquo;`;
  return (
    <div className="mx-auto max-w-screen-sm">
      <div
        dangerouslySetInnerHTML={{ __html: text }}
        className="hyphenate text-center text-2xl italic underline decoration-8 decoration-white [&>p]:inline"
      ></div>
      <div className="mt-4 text-center font-bold text-sm uppercase tracking-2px">{quote?.person?.name}</div>
    </div>
  );
}
